// extracted by mini-css-extract-plugin
export default {"unavailable":"UnavailableMessage-module--unavailable--b1145"};